// Inline calibration prose surfaced under the
// item title when CriteriaCatalogItem.IsCommonExpected is true. Lessons-
// learned note: "Common-expected note prose is a
// calibration trap. The DQR Reference deliberately calls out items that
// are 'common in this market — don't over-react.' Surface this prose
// inline near the item title; don't bury it. Analysts who don't see it
// will over-decline."

import { Info } from "lucide-react";

export function CommonExpectedNote({ text }: { text: string }) {
  return (
    <div className="flex gap-space-2 items-start bg-status-info/10 border border-status-info/30 rounded-md px-space-3 py-space-2">
      <Info size={14} className="text-status-info mt-[2px] shrink-0" aria-hidden />
      <p className="text-caption text-onyx m-0 italic">{text}</p>
    </div>
  );
}
